import { put, takeLatest } from "redux-saga/effects";
import { GetDataMenuRolesSuccessAction, IsResultAction, RequertMenuRolesFailedAction } from "../actions";
import { DELETE_DATA_MENU_ROLES, GET_DATA_MENU_ROLES, SET_DATA_MENU_ROLES } from "../actions/actionTypes";
import { Api } from "./api";


function* GetDataMenuRoles(){
    try{
        const DataMenuRoles = yield Api.GetDataMenuRolesFromApi();
        yield put(GetDataMenuRolesSuccessAction(DataMenuRoles));
    }catch(error){
        yield put(RequertMenuRolesFailedAction(error));
    }
}
export function* watchGetDataMenuRoles(){
    yield takeLatest(GET_DATA_MENU_ROLES,GetDataMenuRoles);
}
function* SetDataMenuRoles(action){
    try {
        const isResult = yield Api.SetDataMenuRolesFromApi(action.DataMenuRoles);
        if (isResult) {
            yield put(IsResultAction(isResult))
        }
        else {
            yield put(RequertMenuRolesFailedAction("error"))
        }
    } catch (error) {
        yield put(RequertMenuRolesFailedAction(error))
    }
}

export function* watchSetDataMenuRoles(){
    yield takeLatest(SET_DATA_MENU_ROLES, SetDataMenuRoles);
}

function* DeleteDataMenuRoles(action){
    try{
        const isResult = yield Api.DeleteMenuRolesFromApi(action.DataDelete);
        if (isResult) {
            yield put(IsResultAction(isResult))
        }
        else {
            yield put(RequertMenuRolesFailedAction("error"))
        }
    }
    catch (error) {
        yield put(RequertMenuRolesFailedAction(error));
    }
}

export function* watchDeleteDataMenuRoles(){
    yield takeLatest(DELETE_DATA_MENU_ROLES, DeleteDataMenuRoles);
}